import React, { useEffect } from 'react';
import { CheckCircle2, AlertCircle, X } from 'lucide-react';

/**
 * 전역 알림 토스트 컴포넌트.
 */
const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
    useEffect(() => {
        if (!message) return;
        const timer = setTimeout(() => {
            onClose();
        }, duration);
        return () => clearTimeout(timer);
    }, [message, duration, onClose]);

    if (!message) return null;

    const styles = {
        success: {
            bg: 'bg-emerald-50',
            border: 'border-emerald-100',
            icon: <CheckCircle2 size={18} className="text-emerald-500" />,
            text: 'text-emerald-800'
        },
        error: {
            bg: 'bg-red-50',
            border: 'border-red-100',
            icon: <AlertCircle size={18} className="text-red-500" />,
            text: 'text-red-800'
        }
    };

    const currentStyle = styles[type] || styles.success;

    return (
        <div className="fixed bottom-10 left-1/2 -translate-x-1/2 z-[200] animate-in slide-in-from-bottom-5 fade-in duration-300">
            <div className={`relative flex items-center justify-center px-12 h-[48px] rounded-xl shadow-xl border ${currentStyle.bg} ${currentStyle.border} w-fit min-w-[260px] max-w-[90vw]`}>
                {/* 왼쪽 아이콘 */}
                <div className="absolute left-4 top-0 bottom-0 flex items-center justify-center">
                    {currentStyle.icon}
                </div>

                {/* 중앙 문구 - div로 태그 변경 및 m-0 적용 */}
                <div className={`text-[13px] font-bold ${currentStyle.text} text-center whitespace-nowrap m-0 p-0 flex items-center h-full`}>
                    {message}
                </div>

                {/* 오른쪽 닫기 버튼 */}
                <button
                    onClick={onClose}
                    className="absolute right-3 top-0 bottom-0 p-1 text-gray-400 hover:text-gray-600 transition-colors flex items-center justify-center"
                >
                    <X size={14} />
                </button>
            </div>
        </div>
    );
};

export default Toast;
